import axios from "axios";

// Backend URL rules: MUST use env var and prefix with /api for routes
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({ 
  baseURL: API,
  withCredentials: false  // Using Bearer token auth, not cookies
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Global 401 handler. When the server rejects our Bearer token (expired,
// revoked, JWT_SECRET rotated, ...), wipe the stale credentials and notify
// the rest of the app via the existing "auth:changed" event so useAuth
// re-hydrates to a signed-out state. Without this, components like the
// notifications poll keep retrying with the dead token every 10s, which
// looks like a freeze/reload loop in the UI.
//
// Only fires when a token was actually attached, so 401s from public
// endpoints (e.g. failed Google sign-in) don't trigger spurious sign-outs.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const hadAuth = Boolean(error?.config?.headers?.Authorization);
    if (status === 401 && hadAuth) {
      const stillHasToken = !!localStorage.getItem("auth_token");
      if (stillHasToken) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
        try { window.dispatchEvent(new Event("auth:changed")); } catch (e) { /* noop */ }
      }
    }
    return Promise.reject(error);
  }
);

